export interface Location {
  id: string;
  city: string;
  state: string;
  slug: string;
  county: string;
  featured: boolean;
}

export const locations: Location[] = [
  { id: '1', city: 'Chicago', state: 'IL', slug: 'chicago-il', county: 'Cook County', featured: true },
  { id: '2', city: 'Evanston', state: 'IL', slug: 'evanston-il', county: 'Cook County', featured: true },
  { id: '3', city: 'Skokie', state: 'IL', slug: 'skokie-il', county: 'Cook County', featured: true },
  { id: '4', city: 'Oak Park', state: 'IL', slug: 'oak-park-il', county: 'Cook County', featured: true },
  { id: '5', city: 'Park Ridge', state: 'IL', slug: 'park-ridge-il', county: 'Cook County', featured: true },
  { id: '6', city: 'Northbrook', state: 'IL', slug: 'northbrook-il', county: 'Cook County', featured: false },
  { id: '7', city: 'Oak Lawn', state: 'IL', slug: 'oak-lawn-il', county: 'Cook County', featured: false },
  { id: '8', city: 'Barrington', state: 'IL', slug: 'barrington-il', county: 'Cook County', featured: false },
  { id: '9', city: 'Bensenville', state: 'IL', slug: 'bensenville-il', county: 'DuPage County', featured: false },
  { id: '10', city: 'Elmhurst', state: 'IL', slug: 'elmhurst-il', county: 'DuPage County', featured: false },
  { id: '11', city: 'Wheeling', state: 'IL', slug: 'wheeling-il', county: 'Cook County', featured: false },
  { id: '12', city: 'Northlake', state: 'IL', slug: 'northlake-il', county: 'Cook County', featured: false },
  { id: '13', city: 'Elgin', state: 'IL', slug: 'elgin-il', county: 'Kane County', featured: false },
  { id: '14', city: 'Berwyn', state: 'IL', slug: 'berwyn-il', county: 'Cook County', featured: false },
  { id: '15', city: 'Burbank', state: 'IL', slug: 'burbank-il', county: 'Cook County', featured: false },
  { id: '16', city: 'Cicero', state: 'IL', slug: 'cicero-il', county: 'Cook County', featured: false },
  { id: '17', city: 'Harwood Heights', state: 'IL', slug: 'harwood-heights-il', county: 'Cook County', featured: false },
  { id: '18', city: 'Elmwood Park', state: 'IL', slug: 'elmwood-park-il', county: 'Cook County', featured: false },
  { id: '19', city: 'Forest Park', state: 'IL', slug: 'forest-park-il', county: 'Cook County', featured: false },
  { id: '20', city: 'Franklin Park', state: 'IL', slug: 'franklin-park-il', county: 'Cook County', featured: false },
  { id: '21', city: 'Lincolnwood', state: 'IL', slug: 'lincolnwood-il', county: 'Cook County', featured: false },
  { id: '22', city: 'Melrose Park', state: 'IL', slug: 'melrose-park-il', county: 'Cook County', featured: false },
  { id: '23', city: 'Norridge', state: 'IL', slug: 'norridge-il', county: 'Cook County', featured: false },
  { id: '24', city: 'Schiller Park', state: 'IL', slug: 'schiller-park-il', county: 'Cook County', featured: false },
];
